var HelpCenter = {
	init:function(){
		$(".help-center .left").find(".menu").on("click touchend", function(e){
			if(e.type == "touchend"){
				$(this).off("click");
			}
			
			$(".help-center .left").find(".menu").removeClass("current");
			$(this).addClass("current");
			
			var _id = $(this).index();
			
			$(".help-center .right").find(".content").each(function(i){				
				if(i == _id){
					$(this).addClass("current");
				}else{
					$(this).removeClass("current");
				}
			});
			
		})
	}
}
$(window).load(function(){
	if($(".help-center").length){
		HelpCenter.init();
	}
})